<!--工作室课程-->
<template>
    <div class="studio_nav_content">
        <!--列表模式-->
        <div class="page-mode" v-if="showMode==='list'">
            <div class="model-container">
                <div :class="activeItem==='1'?'model-item model-active':'model-item'" @click="handleActiveChange('1')">活动管理</div>
                <div :class="activeItem==='2'?'model-item model-active':'model-item'" @click="handleActiveChange('2')">初审审核</div>
                <div :class="activeItem==='3'?'model-item model-active':'model-item'" @click="handleActiveChange('3')">复审审核</div>
                <div :class="activeItem==='4'?'model-item model-active':'model-item'" @click="handleActiveChange('4')">终审审核</div>
            </div>
            <!--竞赛管理-->
            <div class="bre9e" v-show="activeItem==='1'">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 232px)"
                          :data="activityList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column width="90" align="center" label="活动状态" prop="status">
                        <template #default="scope">
                            <div v-if="scope.row.status === 0">初始阶段</div>
                            <div v-if="scope.row.status === 1">报名阶段</div>
                            <div v-if="scope.row.status === 2">初审阶段</div>
                            <div v-if="scope.row.status === 3">复审阶段</div>
                            <div v-if="scope.row.status === 4">终审阶段</div>
                            <div v-if="scope.row.status === 5">现场评比</div>
                            <div v-if="scope.row.status === 6">活动结束</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" label="活动名称" prop="activityName">
                        <template #default="scope">
                            <div :title="scope.row.activityName" style="color: #409efe;" class="text-one cursor">
                                {{ scope.row.activityName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="120" align="center" label="活动范围" prop="activityNature">
                        <template #default="scope">
                            <div v-if="scope.row.activityNature == 1" class="text-one">普通</div>
                            <div v-if="scope.row.activityNature == 2" class="text-one">名师工作室</div>
                            <div v-if="scope.row.activityNature == 3" class="text-one">名校长工作室</div>
                            <div v-if="scope.row.activityNature == 4" class="text-one">群组任务</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="120" align="center" label="活动级别" prop="activityLevelName">
                    </el-table-column>
                    <el-table-column width="120" align="center" label="审核模式" prop="checkModeName">
                    </el-table-column>
                    <el-table-column width="260" align="center" label="报名阶段" prop="time">
                        <template #default="scope">
                            <div>
                                {{ timestampToTime(scope.row.beginTime) }}至{{ timestampToTime(scope.row.endTime) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="180" align="center" label="学段•年级•学科">
                        <template #default="scope">
                            <el-text>
                                {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.gradeName?scope.row.gradeName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                            </el-text>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="100" label="操作" align="center">
                        <template #default="scope">
                            <el-button type="primary" size="small" @click="raceManager(scope.row)">管理</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--审核管理-->
            <div class="bre9e" v-show="activeItem==='2'||activeItem==='3'||activeItem==='4'">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          height="calc(100vh - 232px)"
                          :data="dataList"
                          highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column width="200" align="center" label="活动名称" prop="raceName">
                    </el-table-column>
                    <el-table-column align="center" label="报名时间" width="130" prop="">
                        <template #default="scope">
                            <div>
                                {{ timestampToTime(scope.row.submitTime) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="教师姓名" width="80" prop="trueName"/>
                    <el-table-column width="95" align="center" label="学段学科">
                        <template #default="scope">
                            <el-text>
                                {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                            </el-text>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" align="center" label="所属单位" prop="orgName">
                    </el-table-column>
                    <el-table-column width="80" align="center" label="最高学历" prop="qualificationName">
                    </el-table-column>
                    <el-table-column width="100" align="center" label="技术职称" prop="rankLevelName">
                    </el-table-column>
                    <el-table-column width="200" align="center" label="课例名称" prop="lessonName">
                    </el-table-column>
                    <el-table-column width="100" align="center" label="课堂实录">
                        <template #default="scope">
                            <div>
                                {{ scope.row.ktslFileList.length }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="60" align="center" label="教案">
                        <template #default="scope">
                            <div>
                                {{ scope.row.jaFileList.length }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="60" align="center" label="课件">
                        <template #default="scope">
                            <div>
                                {{ scope.row.kjFileList.length }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" align="center" label="说课附件">
                        <template #default="scope">
                            <div>
                                {{ scope.row.skFileList.length }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="status==='2'" width="90" fixed="right" align="center" label="审核状态">
                        <template #default="scope">
                            <div v-if="scope.row.csStatus===1||scope.row.csStatus===2" class="tab-dfp">未审核</div>
                            <div v-if="scope.row.csStatus===3" class="tab-shtg">已通过</div>
                            <div v-if="scope.row.csStatus===4" class="tab-shjj">已拒绝</div>
                        </template>
                    </el-table-column>

                    <el-table-column v-if="status==='3'" width="90" fixed="right" align="center" label="审核状态">
                        <template #default="scope">
                            <div v-if="scope.row.fsIsRate===0" class="tab-dfp">未审核</div>
                            <div v-if="scope.row.fsIsRate===1" class="tab-shtg">已审核</div>
                        </template>
                    </el-table-column>

                    <el-table-column v-if="status==='4'" width="90" fixed="right" align="center" label="审核状态">
                        <template #default="scope">
                            <div v-if="scope.row.zsIsRate===0" class="tab-dfp">未审核</div>
                            <div v-if="scope.row.zsIsRate===1" class="tab-shtg">已审核</div>
                        </template>
                    </el-table-column>

                    <el-table-column fixed="right" width="100" label="操作" align="center"
                                     class-name="small-padding fixed-width">
                        <template #default="scope">
                            <!--初审审核-->
                            <el-button v-if="status==='2'&&scope.row.csStatus===2" type="primary" size="small" @click="scSignCheck(scope.row)">审核</el-button>
                            <el-button v-if="status==='2'&&scope.row.csStatus!==2" type="primary" size="small" @click="scSignCheck(scope.row)">查看</el-button>
                            <!--复审审核-->
                            <el-button v-if="status==='3'&&scope.row.fsIsRate===0" type="primary" size="small" @click="fsSignCheck(scope.row)">审核</el-button>
                            <el-button v-if="status==='3'&&scope.row.fsIsRate===1" type="primary" size="small" @click="fsSignCheck(scope.row)">查看</el-button>
                            <!--复审审核-->
                            <el-button v-if="status==='4'&&scope.row.zsIsRate===0" type="primary" size="small" @click="zsSignCheck(scope.row)">审核</el-button>
                            <el-button v-if="status==='4'&&scope.row.zsIsRate===1" type="primary" size="small" @click="zsSignCheck(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- 竞赛管理 -->
        <div class="detail-mode" v-if="showMode==='raceDivide'">
            <activity-divide-manager :info-id="this.activityId" @change-active-mode="changeActiveModel"/>
        </div>
        <!-- 初审审核 -->
        <div class="detail-mode" v-if="showMode==='csSignCheck'">
            <cs-activity-sign-check :info-id="signId" :info-status="signStatus"
                                @change-active-mode="changeActiveModel"/>
        </div>
        <!-- 复审审核 -->
        <div class="detail-mode" v-if="showMode==='fsSignCheck'">
            <fs-activity-sign-check :info-id="signId" :rate-status="isRate"
                                @change-active-mode="changeActiveModel"/>
        </div>

        <!-- 终审审核 -->
        <div class="detail-mode" v-if="showMode==='zsSignCheck'">
            <zs-activity-sign-check :info-id="signId" :rate-status="isRate"
                                @change-active-mode="changeActiveModel"/>
        </div>
    </div>
</template>

<script>
import {timestampDate, timestampToTime} from "@/utils/date";
import {listActivitySign} from "@/api/admin/raceSign"
import {listManagerActivity} from "@/api/admin/activity"
import activityDivideManager from "@/components/homeManager/activity/activityDivideManager.vue";
import csActivitySignCheck from "@/components/homeManager/activity/csActivitySignCheck";
import fsActivitySignCheck from "@/components/homeManager/activity/fsActivitySignCheck";
import zsActivitySignCheck from "@/components/homeManager/activity/zsActivitySignCheck";

export default {
    name:'activityManager',
    computed: {},
    components:{zsActivitySignCheck, fsActivitySignCheck, csActivitySignCheck, activityDivideManager},
    props:{
        itemMode:{
            type: String,
            default:'page'
        },
    },
    watch:{
        itemMode(newValue,oldValue){
            this.showMode = newValue;
            this.getCheckList()
        },
    },
    mounted() {
        this.getCheckList()
        this.getRaceList()
    },
    data() {
        return {
            listMode:'list',
            managerMode:'manager',
            csSignCheckMode:'csSignCheck',
            fsSignCheckMode:'fsSignCheck',
            zsSignCheckMode:'zsSignCheck',
            raceDivideMode:'raceDivide',
            showMode:'list',
            activeItem:'1',
            status:'2',
            timestampDate,
            timestampToTime,
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            dataList:[],
            signList:[],
            activityList:[],
            signId:'',
            signStatus:0, //0-查看 1-审核
            activityId:'',
            isRate:0,

        }
    },
    methods: {
        handleActiveChange(activeItem){
            this.activeItem = activeItem;
            this.status = activeItem;
            this.getCheckList()
        },
        getCheckList(){
            listActivitySign({ status: this.status }).then(res => {
                if (res.data.code===1){
                    this.dataList = res.data.data
                }
            })
        },
        scSignCheck(row){
            this.signId = row.signId;
            this.signStatus = 1;
            this.showMode = this.csSignCheckMode;
            this.$emit('change-mode',this.showMode);
        },
        fsSignCheck(row){
            this.signId = row.signId;
            this.isRate = row.fsIsRate;
            this.showMode = this.fsSignCheckMode;
            this.$emit('change-mode',this.showMode);
        },
        zsSignCheck(row){
            this.signId = row.signId;
            this.isRate = row.zsIsRate;
            this.showMode = this.zsSignCheckMode;
            this.$emit('change-mode',this.showMode);
        },
        //子组件传值
        changeActiveModel(model,activeItem){
            this.showMode = model;
            this.activeItem = activeItem;
            console.log("改变了："+activeItem)
            this.$emit('change-mode',this.showMode, 2);
            if (activeItem==='1'){
                this.getRaceList()
            }
            if (activeItem==='2'||activeItem==='3'||activeItem==='4'){
                this.getCheckList()
            }
        },
        getRaceList(){
            listManagerActivity().then(res => {
                if (res.data.code===1){
                    this.activityList = res.data.data
                }
            })
        },
        raceManager(row){
            this.activityId = row.activityId;
            this.showMode = this.raceDivideMode;
            this.$emit('change-mode',this.showMode);
        },
    }

}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
    //font-family: "黑体",serif;
}
.page-mode{
    width: 100%;
    height: auto;
    background-color: #fff;
}
.model-container{
    width: 100%;
    height: 50px;
    display: flex;
    padding-left: 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #0d55a4;
}
.model-item{
    width: auto;
    padding: 0 10px 0 10px;
    height: 28px;
    color: #0d55a4;
    border: 1px solid #0d55a4;
    line-height: 28px;
    margin-right: 20px;
    font-size: 14px;
    border-radius: 6px;
    margin-top: 11px;
    cursor: pointer;
    font-weight: bold;
}
.model-active{
    color: #fff!important;
    border: 1px solid #0d55a4!important;
    background-color: #0d55a4!important;
}


.tab-dfp{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #ffbf6b
}
.tab-dsh{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #4095e5
}
.tab-shtg{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #81b337;
}
.tab-shjj{
    width: 60px;
    height: 24px;
    font-size: 12px;
    border-radius: 12px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    line-height: 24px;
    background-color: #bd3124;
}

.status-info-bm{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #4095e5;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-kt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #ffbf6b;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-zq{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #bd3124;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}
.status-info-jt{
    width: 70px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #81b337;
    font-size: 12px;
    text-align: center;
    color: #fff;
    text-indent: 0!important;
}

</style>